<template>
  <div class="remittance-voucher">
    <div class="remittance-voucher-title">退款信息</div>
    <div v-if="offlineInfo.voucherUrl" class="remittance-voucher-item">
      <div class="label">退款凭证</div>
      <div class="btn-value" @click="toPreview(offlineInfo.voucherUrl)">
        查看
      </div>
    </div>
    <div v-if="offlineInfo.merchantPayTime" class="remittance-voucher-item">
      <div class="label">退款日期</div>
      <div class="value">{{ offlineInfo.merchantPayTime }}</div>
    </div>
    <div v-if="offlineInfo.merchantPayAmount" class="remittance-voucher-item">
      <div class="label">退款金额</div>
      <div class="value">￥{{ offlineInfo.merchantPayAmount }}</div>
    </div>
    <div v-if="offlineInfo.merchantSerialNo" class="remittance-voucher-item">
      <div class="label">回单编号</div>
      <div class="value">{{ offlineInfo.merchantSerialNo }}</div>
    </div>
    <div v-if="offlineInfo.merchantPayer" class="remittance-voucher-item">
      <div class="label">退款人</div>
      <div class="value">{{ offlineInfo.merchantPayer }}</div>
    </div>
    <div v-if="offlineInfo.merchantPayAccount" class="remittance-voucher-item">
      <div class="label">退款账户</div>
      <div class="value">{{ offlineInfo.merchantPayAccount }}</div>
    </div>
    <div v-if="offlineInfo.customerAccountName" class="remittance-voucher-item">
      <div class="label">收款人</div>
      <div class="value">{{ offlineInfo.customerAccountName }}</div>
    </div>
    <div v-if="offlineInfo.customerAccountNo" class="remittance-voucher-item">
      <div class="label">收款账户</div>
      <div class="value">{{ offlineInfo.customerAccountNo }}</div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: {
    // 线下汇款信息
    offlineInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    // 浏览退款凭证图片
    toPreview(img) {
      ImagePreview([this.$global.imgUrl + img]);
    },
  },
};
</script>

<style lang="scss" scoped>
.remittance-voucher {
  margin-top: 12px;
  padding: 0 12px;
  padding-top: 12px;
  width: calc(100% - 1px);
  background-color: #fff;
  border: 1px solid white;
  border-radius: 8px;
  font-size: 14px;
  color: #333333;
  .remittance-voucher-title {
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin-bottom: 18px;
  }
  .remittance-voucher-item {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    .label {
      color: #333333;
    }
    .value {
      color: #666666;
    }
    .btn-value {
      color: #4a79f1;
    }
  }
}
</style>
